var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"800px","height":"400px","background-color":"red"}},[_c('highcharts',{attrs:{"options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }